import api from "../services/api-service";

class CourseSubTopicService {
  createSubTopic(body) {
    try {
      return api.post({
        url: "course-sub-topics/create-sub-topic",
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getAllSubTopics(topic_id, search, page, limit) {
    try {
      let url = "course-sub-topics/get-all-sub-topics?";

      // Handle topic_id (array or single)
      if (Array.isArray(topic_id)) {
        topic_id.forEach(id => {
          url += `topic_id[]=${encodeURIComponent(id)}&`;
        });
      } else if (topic_id) {
        url += `topic_id=${topic_id}&`;
      }

      // Handle search
      if (search) {
        url += `search=${encodeURIComponent(search)}&`;
      }
      
      // Handle pagination
      if (page) {
        url += `page=${page}&`;
      }
      if (limit) {
        url += `limit=${limit}&`;
      }

      return api.get({
        url: url.endsWith('&') ? url.slice(0, -1) : url,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  updateSubTopic(id, body) {
    try {
      return api.put({
        url: `course-sub-topics/update-sub-topic/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  deleteSubTopic(id, body) {
    try {
      return api.delete({
        url: `course-sub-topics/delete-sub-topic/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getSubTopic(id) {
    try {
      return api.get({
        url: `course-sub-topics/get-sub-topic/${id}`,
      });
    } catch (error) {
      return new Error(error);
    }
  }
}
export default new CourseSubTopicService();
